module.exports = __webpack_public_path__ + "static/media/clh-125.486aed64.png";